var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('How'),_c('Download'),_c('Services'),_c('Download'),_c('Youtube'),_c('Versions'),_c('Vision2'),_c('Technology'),_c('Metrics'),_c('Team'),_c('About'),_c('Partners')],1)}
var staticRenderFns = []

export { render, staticRenderFns }